import { useState, useEffect } from 'react';
import { supabase, isSupabaseConfigured } from '../lib/supabase';
import { mockDashboardStats } from '../lib/mockData';
import type { DashboardStats } from '../types';

export function useDashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchStats() {
      console.log('Dashboard fetchStats called');
      setLoading(true);
      setError(null);

      try {
        console.log('isSupabaseConfigured:', isSupabaseConfigured);
        if (!isSupabaseConfigured) {
          console.log('Using mock data');
          setStats(mockDashboardStats);
          setLoading(false);
          return;
        }

        const { data, error: fetchError } = await supabase
          .from('dashboard_stats')
          .select('*')
          .single();

        if (fetchError) throw fetchError;
        setStats(data);
      } catch (err) {
        console.error('Dashboard fetch error:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch stats');
        // Fallback to mock data
        setStats(mockDashboardStats);
      } finally {
        console.log('Dashboard fetchStats finally block, setting loading to false');
        setLoading(false);
      }
    }

    fetchStats();
  }, []);

  return { stats, loading, error };
}
